import styled from "styled-components"

import { minWidth, maxWidth } from "utils"

import CloudinaryImage from "components/cloudinary-image"
import BaseCard from "../base"

export const Card = styled.div`
  margin-bottom: 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Container = styled.div`
  width: 13rem;

  figure {
    width: 100%;
    margin: 0;
  }

  h4 {
    margin-top: 1.7rem;
    font-weight: 500;
    line-height: 1.35;

    ${maxWidth.mobile`
      margin-top: 1rem;
    `}
  }

  p {
    margin-top: 0;
    line-height: 1.35;

    ${maxWidth.mobile`
      margin-top: 0.5rem;
      line-height: 1.35;
    `}
  }
`

export const SquareCard = styled(BaseCard)`
  /* image */
  > a > div {
    background-color: #efeee9;
  }

  /* headline */
  > div > a > h3 {
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.4rem;
    text-transform: uppercase;

    ${minWidth.tablet`
      font-size: 1.8rem;
      line-height: 2.2rem;
    `}
  }
`

export const Image = styled(CloudinaryImage)`
  padding-bottom: 100%;

  img {
    max-width: 100%;
    height: auto;
    border-radius: 50%;
    vertical-align: middle;
    background-color: #f3f3f3;
  }
`

export const Name = styled.h4`
  margin-bottom: 1rem;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.62rem;
  letter-spacing: 0.2rem;
  text-align: left;
  text-transform: uppercase;
  color: #222;
`

export const Description = styled.div`
  display: -webkit-box;
  font-size: 1.2rem;
  line-height: 1.872rem;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`
